import { render, staticRenderFns } from "./table.vue?vue&type=template&id=ed7ebabc&scoped=true&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7ebabc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed7ebabc')) {
      api.createRecord('ed7ebabc', component.options)
    } else {
      api.reload('ed7ebabc', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=ed7ebabc&scoped=true&", function () {
      api.rerender('ed7ebabc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableCom/table.vue"
export default component.exports